import { create } from 'zustand'
import { minutesToMilliseconds } from 'date-fns'
import { devtools } from 'zustand/middleware'

interface ReserveState {
  reserveExpirationTimeInMinutes: number
  defaultExpirationTimeInMinutes: number
  hasError: boolean
  isReserveExpired: boolean
  expireAt: number
  setReserveExpirationTime: (timeInMinutes: number) => void
  setDefaultExpirationTime: (timeInMinutes: number) => void
  resetReserveExpirationTime: () => void
  setReserve(): void
  setHasError(hasError: boolean): void
  setIsReserveExpired(isReserveExpired: boolean): void
}

export const useReserveStore = create<ReserveState>()(
  devtools(
    (set) => ({
      reserveExpirationTimeInMinutes: 15,
      defaultExpirationTimeInMinutes: 15,
      hasError: false,
      expireAt: 0,
      isReserveExpired: false,
      setReserveExpirationTime(timeInMinutes) {
        set(
          { reserveExpirationTimeInMinutes: timeInMinutes },
          false,
          'setReserveExpirationTime'
        )
      },
      setDefaultExpirationTime(timeInMinutes) {
        set(
          {
            defaultExpirationTimeInMinutes: timeInMinutes,
            reserveExpirationTimeInMinutes: timeInMinutes
          },
          false,
          'setDefaultExpirationTime'
        )
      },
      resetReserveExpirationTime() {
        set(
          (state) => ({
            reserveExpirationTimeInMinutes: state.defaultExpirationTimeInMinutes
          }),
          false,
          'resetReserveExpirationTime'
        )
      },
      setIsReserveExpired: (isReserveExpired: boolean) =>
        set({ isReserveExpired }, false, 'setIsReserveExpired'),
      setReserve: () =>
        set(
          (state) => ({
            expireAt:
              new Date().getTime() +
              minutesToMilliseconds(state.reserveExpirationTimeInMinutes),
            hasError: false,
            isReserveExpired: false
          }),
          false,
          'setReserve'
        ),
      setHasError: (hasError: boolean) =>
        set({ hasError, isReserveExpired: hasError }, false, 'setHasError')
    }),
    {
      name: 'useReserveStore',
      anonymousActionType: 'useScheduleStore'
    }
  )
)
